module.exports = "../fonts/icon-back.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-back.svg
// module id = 298
// module chunks = 0